import { EventEmitter, Injectable } from '@angular/core';
import { CompartirWebComponent } from '../components/compartir-web/compartir-web.component';
import { PopoverController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})

export class CompartirService {
  url: string = environment.url;
  emitDownloable = new EventEmitter();
  constructor(private popoverCtrl?: PopoverController, private http?: HttpClient) {}

  public async compartir(ev: any, shareData) {
    try {
      await navigator.share(shareData);
    } catch (err) {
      const popover = await this.popoverCtrl.create({
        component: CompartirWebComponent,
        componentProps: { shareData },
        mode: 'ios',
        event: ev,
        cssClass: 'popShare',
      });

      await popover.present();
    }
  }

  emitDownload(prompt){
    this.emitDownloable.emit(prompt)
  }

  postComment(body){
    return this.http.post(`${this.url}/comments/create`, body);
  }

  showComments(type, id){
    return this.http.get(`${this.url}/comments/show/${type}/${id}`);
  }

  categoriesHome(){
    return this.http.get(`${this.url}/categories/home`);
  }
}
